import Axios from "@/Axios";

class TechnicalissueService{

    async getTechnicalissue(data={}){
        return await Axios.get('wms.wms.api.technical_issue.get_technical_issues',{
            params:data
        })
    }
    async createTechnicalissue(data){
      return await Axios.post('wms.wms.api.technical_issue.create_technical_issue',data)
    }
    async deleteTechnicalissue(technicalIssue){
        const transformedTechnicalIssue = technicalIssue.map(item => ({ name: item }));
        return await Axios.delete('wms.wms.api.technical_issue.delete_technical_issues',{data:{technical_issue:transformedTechnicalIssue}})
    }

}
export default  new TechnicalissueService()